import { modals } from '@mantine/modals';
import { useTranslation } from 'react-i18next';

export const useWelcomeVideoModal = () => {
  const { t } = useTranslation();

  const openModal = (onConfirm?: () => void) => {
    modals.openContextModal({
      modal: 'welcomeVideo',
      title: t('welcomeModal.title', 'Bienvenue !'),
      size: 'xl',
      innerProps: {
        onConfirm: () => {
          onConfirm?.();
        },
      },
    });
  };

  return openModal;
};
